import React from 'react';
import Config from './axios/Config';
import axios from 'axios'
import Cookie from 'js-cookie';
import { ContextConsumer } from './MyContext';

export const getUserAuthorizations = async () => { // called in Template.js
    if (!Cookie.get('token')) return;
    let url = process.env.REACT_APP_BASE_API_URL + 'authorization/getUserAuthorizations'

    let headers = {
        Authorization: 'Bearer ' + Cookie.get('token')
    }
    return await axios.get(url, Config(headers)).then(res => {

        let user_authorizations = res.data.data.reduce((persistentObject, curValue) => {
            persistentObject[curValue.authorization_action_key] = curValue.is_authorized;
            return persistentObject;
        }, {});
        return user_authorizations;
    }).catch((error) => {
        console.log(error)
        return {}
    });
}

export const CanAccess = ({ role, yes, no }) => {
    return (
        <ContextConsumer>{(context) => {
            let { user_authorizations } = context;
            let mode = ""
            if (Array.isArray(role)) for (let i = 0; i < role.length; i++) {
                if (role[i] in user_authorizations) {
                    if (user_authorizations[role[i]]) {
                        mode = "yes";
                        break;
                    }
                    else mode = "no";
                }
            }
            if (role in user_authorizations) {
                if (user_authorizations[role]) mode = "yes";
                else mode = "no";
            }
            if (mode === "yes") return yes;
            else if (mode === "no") return no;

        }}</ContextConsumer>
    )
}

export const AuthorizationList = {
    master_data_vendor_view: 'master_data_vendor_view',
    master_data_vendor_add: 'master_data_vendor_add',
    master_data_vendor_edit: 'master_data_vendor_edit',
    master_data_vendor_delete: 'master_data_vendor_delete',

    master_data_color_view: 'master_data_color_view',
    master_data_color_add: 'master_data_color_add',
    master_data_color_edit: 'master_data_color_edit',
    master_data_color_delete: 'master_data_color_delete',

    master_data_country_view: 'master_data_country_view',
    master_data_country_add: 'master_data_country_add',
    master_data_country_edit: 'master_data_country_edit',
    master_data_country_delete: 'master_data_country_delete',

    master_data_goat_pen_view: 'master_data_goat_pen_view',
    master_data_goat_pen_add: 'master_data_goat_pen_add',
    master_data_goat_pen_edit: 'master_data_goat_pen_edit',
    master_data_goat_pen_delete: 'master_data_goat_pen_delete',

    master_data_goat_type_view: 'master_data_goat_type_view',
    master_data_goat_type_add: 'master_data_goat_type_add',
    master_data_goat_type_edit: 'master_data_goat_type_edit',
    master_data_goat_type_delete: 'master_data_goat_type_delete',

    master_data_grade_view: 'master_data_grade_view',
    master_data_grade_add: 'master_data_grade_add',
    master_data_grade_edit: 'master_data_grade_edit',
    master_data_grade_delete: 'master_data_grade_delete',

    master_data_owner_view: 'master_data_owner_view',
    master_data_owner_add: 'master_data_owner_add',
    master_data_owner_edit: 'master_data_owner_edit',
    master_data_owner_delete: 'master_data_owner_delete',

    master_data_supplier_view: 'master_data_supplier_view',
    master_data_supplier_add: 'master_data_supplier_add',
    master_data_supplier_edit: 'master_data_supplier_edit',
    master_data_supplier_delete: 'master_data_supplier_delete',

    kambing_add: 'kambing_add',
    kambing_edit: 'kambing_edit',
    kambing_view: 'kambing_view',
    kambing_delete: 'kambing_delete',
    kambing_gallery_upload: 'kambing_gallery_upload',
    kambing_gallery_view: 'kambing_gallery_view',
    kambing_gallery_delete: 'kambing_gallery_delete',
    kambing_tree_view: 'kambing_tree_view',

    food_feeding_view: 'food_feeding_view',
    food_feeding_feed: 'food_feeding_feed',

    food_food_view: 'food_food_view',
    food_food_add: 'food_food_add',
    food_food_edit: 'food_food_edit',
    food_food_delete: 'food_food_delete',

    food_bungker_view: 'food_bungker_view',
    food_bungker_add: 'food_bungker_add',
    food_bungker_edit: 'food_bungker_edit',

    master_data_section_view: 'master_data_section_view',
    master_data_section_add: 'master_data_section_add',
    master_data_section_edit: 'master_data_section_edit',
    master_data_section_delete: 'master_data_section_delete',

    master_data_section_type_view: 'master_data_section_type_view',
    master_data_section_type_add: 'master_data_section_type_add',
    master_data_section_type_edit: 'master_data_section_type_edit',
    master_data_section_type_delete: 'master_data_section_type_delete',

    master_data_goat_birth_type_view: "master_data_goat_birth_type_view",
    master_data_goat_birth_type_add: 'master_data_goat_birth_type_add',
    master_data_goat_birth_type_edit: 'master_data_goat_birth_type_edit',
    master_data_goat_birth_type_delete: 'master_data_goat_birth_type_delete',

    mating_preparation: "mating_preparation",

    mating_plan_view: "mating_plan_view",
    mating_plan_edit: "mating_plan_edit",
    mating_plan_delete: "mating_plan_delete",
    mating_plan_finish: "mating_plan_finish",

    setting_menu_authorization_view: 'setting_menu_authorization_view',
    setting_menu_authorization_update: 'setting_menu_authorization_update',

    master_data_admin_view: 'master_data_admin_view',
    master_data_admin_add: 'master_data_admin_add',
    master_data_admin_edit: 'master_data_admin_edit',

    kambing_approve_kematian: 'kambing_approve_kematian',

    master_data_family_name_view: 'master_data_family_name_view',
    master_data_family_name_save: 'master_data_family_name_save',
    master_data_family_name_delete: 'master_data_family_name_delete',
}